// ./src/components/RatingTable/index.js

import RatingTableWrapper from './RatingTableWrapper.vue';

export default RatingTableWrapper;
